import React, { useState, useEffect, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { SketchPicker } from 'react-color';

import Modal from '@/components/Modals/Modal';
import { BodyWrapper } from './styles';
// TODO: refactoring. render in one place of app.
// check of rendering of picker

const defaultColor = '#000000';

export const ColorSelectModal = ({ open, setOpen, onChange}) => {
  const [selectedColor, setSelectedColor] = useState(defaultColor);

  const handleClose = () => {
    setOpen(false);
  };
  const handleColorApply = () => {
    onChange(selectedColor);
    handleClose();
  };

  const handleColorChange = useCallback(({ rgb: color }) => {
    setSelectedColor(`rgba(${color.r},${color.g},${color.b},${color.a})`);
  }, []);

  useEffect(() => setSelectedColor(defaultColor) , [open]);

  return (
    <Modal
      title={<FormattedMessage id="app.editor.modal.selectColor" defaultMessage="Select color" />}
      open={open}
      setOpen={setOpen}
      handleClose={handleClose}
      handleApply={handleColorApply}
    >
      <BodyWrapper>
        <SketchPicker
          width="100%"
          color={selectedColor}
          onChangeComplete={handleColorChange}
        />
      </BodyWrapper>
    </Modal>
  );
};

export default React.memo(ColorSelectModal);
